import axios from "axios";
import config from "../resources/Config";

const toLocalFormat = (number) => {
    return number.toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    });
}

const mapToProductObject = (xmlResponseData, productData) => {
    return {
        itemId: productData.itemId,
        name: productData.productName,
        priceGuaranteeDate: productData.productPriceGuaranteeDate,
        orderLink: productData.productOrderLink,
        salesCompany: productData.salesCompany,
        totalCost: toLocalFormat(Number(xmlResponseData.gesamt_kosten.replace('.', '').replace(',', '.')) / 12).slice(0, -1),
        basePrice: xmlResponseData.festpreis,
        consumptionPrice: xmlResponseData.arbeitspreis_ht,
        validFrom: xmlResponseData.gueltig_ab
    }
};

export const getProductsService =
    async ({ zipcode, consumption, itemId, division }) => {
        const res = await axios.get(`${config.flatgas.productsUrl}?division=${division}&consumption=${consumption}&zipcode=${zipcode}&itemId=${itemId}`);
        const xmlResponseData = res.data.xmlResponseData[0];
        const productData = res.data.scData[0];

        if (!xmlResponseData || !productData) {
            return { error: { code: config.flatgas.code.gerneral, message: config.flatgas.error.generalErrorMessage } }
        }

        if (xmlResponseData.errorCode) {
            return { error: { code: config.flatgas.code.zipcode, errorCode: xmlResponseData.errorCode, message: xmlResponseData.errorMessage } }
        }
        const minConsumption = +xmlResponseData.mindestverbrauch;
        const maxConsumption = +xmlResponseData.hoechstverbrauch;

        if (consumption < minConsumption || consumption > maxConsumption) {

            return { error: { code: config.flatgas.code.consumption, message: config.flatgas.error.consumptionRangeValidation } }
        }
        return mapToProductObject(xmlResponseData, productData);
    }
